export const nagodba = {
    templateId: 232,
    category: 5,
    templateTitle: 'Sporazum – izvansudska nagodba o podmirenju duga',
    templateDescription: `<p>Ugovorne strane nagodbom prekidaju spor, otklanjaju neizvjesnost ili drugačije uređuju postojeća uzajamna prava i obveze.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Nagodba je ugovor između osoba koje su u sporu ili između kojih postoji neizvjesnost o nekom međusobnom pravnom odnosu.</p>
    <p>Ugovorne strane nagodbom:</p>
    <li>prekidaju spor i/ili,</li>
    <li>otklanjaju neizvjesnost i/ili,</li>
    <li>određuju svoja uzajamna prava i obveze.</li>
    <br>
    <p>Navedeno se ostvaruje uzajamnim popuštanjima koje se mogu sastojati npr. u djelomičnom ili potpunom priznavanju nekog od zahtjeva druge strane ili u odricanju od nekoga svog zahtjeva, preuzimanju neke nove obveze, smanjenju kamatne stope, produljenju roka, pristajanju na obročnu otplatu i sl..</p>
    <p><strong>Vrlo je važno naglasiti da nagodba kojom se priznaje dug, određuje obročna oplata i sl., utječe na zastaru.</strong></p>
    <p><strong>U tom smislu, ukoliko se nagodbom priznaju obveze koje nisu zastarjele to rezultira prekidom zastare (zastarni rokovi počinju iznova teći), a priznanje obveza koje su već zastarjele smatra se odricanjem od zastare.</strong></p>
    <p>Sudska praksa navodi da priznanje duga mora biti nedvojbeno, određeno i jasno.</p>
    <p>Ako je nagodbom učinjena obnova obveze, jamac se oslobađa odgovornosti za njezino ispunjenje, a prestaje i zalog koji je dao netko treći, no jamac i treći koji je dao svoju stvar u zalog ostaju i nadalje u obvezi. Jamac i zalogodavac zadržavaju pravo da istaknu vjerovniku prigovore kojih se dužnik nagodbom odrekao.</p>
    <p>Odredbe teksta nagodbe čine cjelinu te ako je jedna odredba ništetna, cijela nagodba je ništetna, osim kad se iz same nagodbe vidi da se ona sastoji od neovisnih dijelova.</p>
    <p>Sadržaj nagodbe u nastavku je uobičajen za reguliranje  uobičajenih razloga sklapanja nagodbe, priznanja novčane obveze te produženje roka plaćanja uz ugovaranje obročnu otplatu.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

    
  sides: [
    {
        signature: 'Vjerovnik:',
        inputs: [{
            type: 'input',
            required: true,
            placeholder: 'Poslovni subjekt',
        },
            {
                type: 'input',
                required: true,
                placeholder: 'Ulica i kućni broj',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'Mjesto',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'OIB',
            },
            {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
            }],
        suffix: ' (u daljnjem tekstu: Vjerovnik)',
        delimiter: `i`
    },
    {
        signature: 'Dužnik:',
        inputs: [{
            type: 'input',
            required: true,
            placeholder: 'Posl. subjekt / Ime i prezime',        
        },
            {
                type: 'input',
                required: true,
                placeholder: 'Ulica i kućni broj',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'Mjesto',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'OIB',
            },
            {
                type: "input",
                placeholder: "Zastupa (za pr. osobe)",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija (za pr. osobe)",
                inSignature: true,
            }],
        suffix: ' (u daljnjem tekstu: Dužnik)',
    }
],

headline: 'zaključuju sljedeći',
title: 'SPORAZUM – IZVANSUDSKU NAGODBA O PODMIRENJU DUGA',
noArticleNumbers: false,

articles: [

    {
        title: 'UVODNE ODREDBE',
        mandatory: false,
        exampleContent: true, 
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                help: "Ovdje upisujete predmet međusobnih prava i obveze koje se reguliraju nagodbom.",
                content: 'Stranke Sporazuma suglasno utvrđuju da Dužnik ima dugovanja prema Vjerovniku određena ovim Sporazumom.',
                value: '',
            }],
    },
    {
        title: 'DUG DUŽNIKA',
        mandatory: false,
        exampleContent: true, 
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                help: "Ovdje pobliže definirate odnosno specificirate iznos obveza odnosno detaljnije opisujete međusobna prava i obveze.",
                content: 'Ovim Sporazumom, stranke Sporazuma suglasno utvrđuju da ukupan dospjeli dug Dužnika prema Vjerovniku na dan sklapanja ovog Sporazuma iznosi kako slijedi: \r\n- glavnica _____ kn, \r\n- kamate _____ kn,\r\n- troškovi postupka _____ kn. ',
                value: '',
            }],
    },
    {
        title: 'REGULIRANJE MEĐUSOBNIH OBVEZA',
        mandatory: true,
        exampleContent: true, 
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                help: "Prijedlog teksta odnosi se na situaciju u kojoj se produljuje rok isporuke te određuju obročnu otplate duga. Svakako da dogovor stranaka može biti i drugačiji, stoga mijenjate odredbe ovom članka sukladno dogovoru stranaka.",
                content:'Ovom nagodbom stranke Sporazuma reguliraju svoje međusobne odnose na način da produljuju rok ispunjenja duga Dužnika iz ovog Sporazuma te ugovaraju obročnu otplatu kako se određuje u nastavku. \r\nS obzirom na navedeno, Dužnik će obavljati plaćanja dug Vjerovniku prema sljedećem otplatnom planu: \r\n- prvu ratu od ______ kn Dužnik će platiti Vjerovniku do ___ .___. _____. godine, \r\n- drugu ratu od ______ kn Dužnik će platiti Vjerovniku do ___ .___. _____. godine.',
                value: '',
            }],
    },
    {
        title: 'PRIJEVREMENA OTPLATA',
        mandatory: false, 
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Dužnik može izvršiti otplatu dijela duga ili ukupnog iznosa duga i prije rokova određenih ovim Sporazumom bez obveze prethodnog obavještavanja Vjerovnika.',
                value: '',
            }],
    },
    {
        title: 'KAŠNJENJE',
        mandatory: false, 
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ako Dužnik kasni s uplatama više od dvije rate iz ovog Sporazuma, stranke Sporazuma se sporazumijevaju da odmah na naplatu dospijeva cjelokupan iznos duga, zajedno sa svim kamatama.',
                value: '',
            }],
    },
    {
        title: 'DODATNE OBVEZE DUŽNIKA',
        mandatory: false, 
        exampleContent: true,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Dužnik se do trenutka podmirenja cjelokupnog duga prema Vjerovniku obvezuje  izvještavati Vjerovnika o svim promjenama koje se upisuju/mijenjaju u sudski/obrtni ili drugi registar, odnosno o promjenama u kartonu deponiranih potpisa kod Financijske agencije ili poslovne banke i to u roku od 8 dana od dana podnošenja prijedloga promjene, ali i na pisani zahtjev Vjerovnika, dostaviti Vjerovniku bez odgode poslovnu dokumentaciju nužnu za procjenu njegova boniteta i kreditne sposobnosti Dužnika (prije svega Bilancu, Račun dobiti i gubitka, BON 2, PD obrazac, izvod iz sudskog/obrtnog registra, obavijest Državnog zavoda o razvrstavanju i potpisni karton) odnosno odmah po saznanju o blokadi računa, o istoj obavijestiti Vjerovnika.  \r\nStranke Sporazuma su također suglasne da ukoliko Dužnik ne izvještava Vjerovnika o okolnostima iz prethodnog stavka ovog članka, kao i u slučaju pokretanja predstečajne nagodbe ili podnošenja prijedloga za otvaranje stečajnog postupka nad Dužnikom na naplatu dospijeva cjelokupan iznos duga, zajedno sa svim kamatama.',
                value: '',
            }],
    },
    {
        title: 'PREOSTALE MEĐUSOBNE OBVEZE',
        mandatory: false,
        required: true,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Odredbe ovog Sporazuma primjenjuju se isključivo na dugovanja koja su navedena u Sporazumu, stoga prava i obveze iz eventualnih preostalih međusobnih odnosa stranaka Sporazuma ostaju neizmijenjena. ',
                value: '',
            }],
    },
    {
        title: 'PRIMJENA NAGODBE',
        mandatory: false,
        exampleContent: true, 
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Stranke Sporazuma suglasno ustvrđuju da se ovaj Sporazum primjenjuje od dana potpisa stranaka Sporazuma.',
                value: '',
            }],
    },

    {
        title: 'NADLEŽNOST',
        mandatory: false,
        statements: [
            {
                type: 'choice',
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                            {
                                type: 'text',
                                content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Sporazumom rješavati će se pred stvarno nadležnim sudom za Vjerovnika.'
                            }
                        ]
                    },
                    {
                        parts: [
                            {
                                type: 'text',
                                content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Sporazumom rješavati će se pred stvarno nadležnim sudom za Dužnika.'
                            }
                        ]
                    },
                    {
                        parts: [
                            {
                                type: 'text',
                                content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Sporazumom rješavati će se pred stvarno nadležnim sudom u'
                            },
                            {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                            ]
                    }
                ],
                value: '',
            }
        ]
    },
    {
        title: 'ZAVRŠNE ODREDBE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Sporazumne stranke potvrđuju da su sadržaj Sporazuma razumjele i da je on iskaz njihove prave volje te ga bez ikakvih mana volje (prijetnja, sila, zabluda i sl.) potpisuju u znak suglasnosti. \r\nStranke Sporazuma suglasno utvrđuju da su iste sposobne raspolagati pravima koja se predmet ovog Sporazuma te sklapanjem ovog Sporazuma prihvaćaju sva prava i obveze koje proizlaze iz Sporazuma.',
                value: '',
            }],
    },
    {
        title: 'PRIMJERCI SPORAZUMA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ovaj Sporazum sastavljen je u 2 (dva) primjerka, od kojih svaka strana Sporazuma zadržava po 1 (jedan) primjerak.',
                value: '',
            }],
      },
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              {
                type: "text",
                content: "U"
              },
              {
                type: "input",
                value: "",
                placeholder: "Upišite mjesto.",
                required: true,
              },
              {
                type: "text",
                content: ", dana"
              },
              {
                type: "date",
                value: new Date(),
                required: true
              },
              {
                type: "text",
                content: "godine."
              }
            ]
          },
        ]
      },
    {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
    },
],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/232_nagodba.ts